<template>
  <div class="physicalExamination">
    <top :toolSort="toolSort"></top>
    <div class="toolDesc">
    </div>
    <!-- 具体工具模块 -->
    <div :class="['toolMain',{mobileFontSize:$isMobile}]">
      <div class="harmfulTable">
        <div class="select">
          <el-radio :label="0" v-model="checkSort">全部</el-radio>
          <el-radio v-model="checkSort" v-for="(item,i) in sortList" :key='i' :label="item">{{item}}</el-radio>
          <el-input size='mini' v-model="searchKeys" clearable type="" placeholder="请输入关键字" @input="findKeywords">
                    <i class="el-icon-search" type="primary" @click="findKeywords" slot='suffix'></i>

          </el-input>
        </div>
        <div class="keywordList">
          <div v-show="value!=undefined&&value.length" class="keywordItem" v-for="(value,key,index) in keyWordObj" :key='index'>
            <div :class="['firstPin',{mobileFontSize:$isMobile}]">
              <span>{{key}}</span>
            </div>
            <el-checkbox-group v-model="checkList">
              <el-checkbox :label="item.keyword" v-for="(item,i) in value" :key='i'></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div :class="['keyWord',{mobileFontSize:$isMobile}]">
        <div :class="['keywordLabel',{mobileFontSize:$isMobile}]">关键词：</div>
        <span v-show="checkList!=undefined&&checkList.length===0">暂未选择关键词</span>
        <el-tag type="info" @close="closeTag(i)" v-for="(tag,i) in checkList" :key="i" closable>
          {{tag}}
        </el-tag>
      </div>
      <el-select size='mini' :class="{mobileFontSize:$isMobile}" v-model="status" placeholder="请选择">
        <el-option v-for="(item,i) in statusList" :key="i" :label="item" :value="item">
        </el-option>
      </el-select>
      <el-button type="primary" @click='getExamRes' size="mini">推荐结果</el-button>
      <el-button type="warning" plain="" size="mini" @click='checkList = []'>清空关键词</el-button>
      <json-excel type='xls' class="json2excel" :fields='json_fields' :data='testResult' :title='`(${testResult[0]&&testResult[0].status.statusCode})多谱检测有限公司体检项目--${new Date().toLocaleString("chinese",{ year: "numeric", month: "2-digit",
            day: "2-digit" })}`'
        :name='`(${testResult[0]&&testResult[0].status.statusCode})多谱检测有限公司体检项目--${new Date().toLocaleString("chinese",{ year: "numeric", month: "2-digit",
            day: "2-digit" })}`'>
            <el-button size="mini" :disabled='!testResult[0]'>导出excel</el-button>
            </json-excel>
      <el-button plain="" @click="getPdf()" size="mini" :disabled='!testResult[0]'>导出pdf</el-button>
      <div id="pdfdom">
        <h5 class="tableTitle">({{testResult[0]&&testResult[0].status.statusCode}})多谱检测有限公司体检项目--{{new Date().toLocaleString("chinese",{ year: "numeric", month: "2-digit",
            day: "2-digit" })}}</h5>

         <!-- PC端 -->
        <el-table size='mini' id="examTable" v-show="showRes&&!$isMobile" :highlight-current-row='true' :data='testResult' :border="true">
          <el-table-column fixed align='center' prop="keyword" label="危害因素或作业"></el-table-column>
          <el-table-column align='center' label="体检项目(必检)">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.status.examItem }}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label="体检周期">
            <template slot-scope="scope">
              <p v-show="scope.row.status.cycle!=undefined&&scope.row.status.cycle.length==0">/</p>
              <p v-show="scope.row.status.cycle!=undefined&&scope.row.status.cycle.length!=0" v-for="(item,i) in scope.row.status.cycle"
                :key='i' style="margin-left: 10px">{{item}}</p>
            </template>
          </el-table-column>
          <el-table-column align='center' label="职业病">
            <template slot-scope="scope">
              <p v-show="scope.row.status.workDiseases!=undefined&&scope.row.status.workDiseases.length==0">/</p>
              <p v-show="scope.row.status.workDiseases!=undefined&&scope.row.status.workDiseases.length!=0" v-for="(item,i) in scope.row.status.workDiseases"
                :key='i' style="margin-left: 10px">{{item}}</p>
            </template>
          </el-table-column>
          <el-table-column class-name='maxHeight' align='center' label="职业禁忌证" max-height='200'>
            <template slot-scope='scope'>
              <p v-show="scope.row.status.forbid!=undefined&&scope.row.status.forbid.length==0">/</p>
              <p v-show="scope.row.status.forbid!=undefined&&scope.row.status.forbid.length!=0" v-for="(item,i) in scope.row.status.forbid.slice(0,5)"
                :key='i' style="margin-left: 10px">{{item}}</p>
              <p v-show="scope.row.status.forbid.length>5">......</p>
            </template>
          </el-table-column>
        </el-table>

        <!-- 移动端 -->
        <el-table
        class="mobileTable"
         v-show="showRes&&$isMobile"
            :data="testResult"
            size='mini'
            style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="scope">
                <el-form label-position="left" class="demo-table-expand">
                  <el-form-item label="体检周期">
                    <span>{{ scope.row.status.cycle.join(';') }}</span>
                  </el-form-item>
                  <el-form-item label="职业病">
                    <span>{{ scope.row.status.workDiseases.join(';') }}</span>
                  </el-form-item>
                  <el-form-item label="职业禁忌症">
                    <span>{{ scope.row.status.forbid.join(';') }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column
              label="危害因素"
              prop="keyword"
              >
            </el-table-column>
            <el-table-column
              label="体检项目"
             >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.status.examItem }}</span>
              </template>
            </el-table-column>
          </el-table>
      </div>

    </div>
  </div>

</template>

<script>
  import top from '../subComponents/top.vue'
  import orderByFirstPin from '@/util/oderByFirstPin.js'
  import JsonExcel from 'vue-json-excel'
  export default {
    data() {
      return {
        htmlTitle:"",
        nowTime:(new Date()).getTime(),
        toolSort: null,
        resultStatus: '', //体检结果状态 ---上岗前，在岗，离岗
        json_fields: {
          '危害因素': 'keyword',
          '体检项目': 'status.examItem',
          '职业病': 'status.workDiseases',
          '体检周期': 'status.cycle',
          '职业禁忌症': 'status.forbid'
        },
        toolInfo: {},
        FirstPin: ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "Q", "R", "S", "T", "W", "X",
          "Y", "Z"
        ],
        statusList: ["上岗前", "在岗", "离岗"],
        status: "在岗",
        checkSort: 0, //被选中的关键词分类
        sortList: ["化学因素", "粉尘", "物理因素", "生物因素", "特殊作业"],
        searchKeys: '',
        selectTool: '',
        //toolList: ['计算', '检测', '体检', '制作简历', '格式化'],
        showRes: false, //显示推荐结果表格
        checkList: [],
        keyWordObj: {},
        showHarmfulTable: false,
        testResult: [],
        input:"",
      }
    },
    components: {
      JsonExcel,
      top
    },
    created() {
      this.toolSort = this.$route.params.sort
      this.getAllKeyword()
      //按回车键触发
      document.onkeydown = e => {
        let key = window.event.keyCode
        if (key === 13) {
          this.findKeywords()
        }
      }
    },
    mounted() {

    },
    watch: {
      checkSort(newVal) {
        console.log(this.checkSort)
        this.findKeywords()

      },
      searchKeys(newVal) {
        if (!newVal) this.findKeywords()
      }
    },
    methods: {
      topdf(){
         htmlToPdf.ExportSavePdf(this.htmlTitle,this.nowTime)
      },
      closeTag(i) {
        this.checkList.splice(i, 1)
      },

      async getAllKeyword() {

        let res = await this.$axios.get(this.$serviceAPI.findAllExam)
        this.keyWordObj = orderByFirstPin(res.data.data, 'keyword')

      },
      //条件查询危害因素关键字
      async findKeywords() {
        console.log(this.searchKeys)
        let res = await this.$axios.post(this.$serviceAPI.findKeywords, {
          keyword: this.searchKeys,
          sort: this.checkSort
        })
        console.log(res)
        if (res.data.data && res.data.data.length === 0) {
          this.message({
            message: '暂无数据，换个关键词试试吧',
            type: 'error'
          })
        }
        this.keyWordObj = orderByFirstPin(res.data.data, 'keyword')
      },
      getExamRes() {
        this.showRes = true
        this.$axios.post(this.$serviceAPI.findListsByKeyword, {
          keywords: this.checkList,
          status: this.status
        }).then(res => {
          this.testResult = res.data.data
          this.htmlTitle = `(${this.testResult[0]&&this.testResult[0].status.statusCode})多谱检测有限公司体检项目--${new Date().toLocaleString("chinese",{ year: "numeric", month: "2-digit",
            day: "2-digit" })}`
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../../assets/iconfont.css");

  @media print {}
  /* 专用的打印样式 */
  @page {
    /* size: auto; //默认的*/
    size: 10cm 25cm; /* 纸张大小 */
    /* size: A4 landscape; portrait/landscape //使用系统中的纸张和方向 */
    margin: 0; /* 清除打印文档的边距 */
    height: 100%;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .tableTitle{
    text-align: center;
    display: none;
  }
  .el-radio{
    margin-right: 1rem;
  }
  /* .el-button+.el-button{
    margin-left: 0;
    margin-bottom: 0.5625rem;
  }
  .el-button{
    margin-bottom: 0.625rem;
  } */
  .keywordItem {
    display: flex;
  }

  .keywordList {
    max-height: 8rem;
    overflow: scroll;
    width: 100%;
  }


  .firstPin {
    font-size: 14px;
    color: #777;

    margin-right: 1.25rem;
  }

  .top {
    width: 66.875rem;
  }

  .iconsousuo {
    cursor: pointer;
    float: right;
  }
  /* .el-input__inner{
    height: 2rem !important;
  } */


  .el-input {
    width: 9rem;
    font-size: 14px;
    margin-bottom: 0.325rem;
  }

  /* .el-input__inner {
    height: 1.9375rem;
    line-height: 1.9375rem;
  } */
  .el-tag{
    line-height: 1.5rem;
    height: 1.5rem;
  }
  .toolMain {
    margin-top: 1.25rem;
  }

  /* .el-button {
    padding: 0.4375rem 0.625rem;
  } */

  .iconlinecar105 {
    font-size: 12px;
  }

  .harmfulTable {
    line-height: 2rem;
    margin-top: 1.25rem;
    padding-left: 1.1rem;
    border: 1px solid #EEEEEE;
    background: whitesmoke;
  }
  .keywordLabel{
    display: inline-block;
  }
  .json2excel{
    display: inline-block;
  }
  .keyWord {
    /* display: flex;
    align-items: center; */
    margin-top: 1.25rem;
    font-size: 14px;
    color: #666;
    padding-bottom: 1.25rem;
    padding-left: 0.1875rem;
    padding-bottom: .6rem;
    width: 100%;
    white-space: pre-line;
  }


  .el-tag.el-tag--info {
    margin-right: 1rem;
    margin-bottom: 0.625rem;
  }

  .el-table {
    margin-top: 1.25rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/subPage/physicalExamination.vue